export const NO_RETURN_POLICY_TEXT = `No Return, Replacement & Refund Policy

This product is non-returnable for reasons such as change of mind or personal preference. However, customers may raise a claim for products that are damaged, defective, incorrect, tampered with, or significantly different from the product description.

Claim Process: Customers must submit a claim through Aivimart Customer Support within the applicable claim period, providing order details and supporting photographs or videos.

Replacement: Following verification and approval, a replacement may be arranged, subject to product availability and applicable policy terms.

Refund: If a replacement is unavailable or otherwise not appropriate, an eligible refund will be processed in accordance with Aivimart’s Refund Policy.

All claims are subject to verification, Aivimart’s Return & Refund Policy, and applicable consumer protection laws in India.`;

